import React, { ReactElement } from 'react';

import { TTextInputProperties } from './text-input.types';
import { StyledInput, StyledWrapper } from './text-input.styled';

export function TextInput({
    width = 'default',
    hasError = false,
    renderPrepended,
    ...properties
}: TTextInputProperties): ReactElement {
    let prependedElement;

    if (typeof renderPrepended === 'function') {
        prependedElement = renderPrepended();
    }

    return (
        <>
            <StyledWrapper>
                {prependedElement ? <span>{prependedElement}</span> : null}
            </StyledWrapper>
            <StyledInput
                aria-invalid={hasError}
                hasError={hasError}
                width={width}
                hasPrepended={typeof renderPrepended === 'function'}
                {...properties}
            />
        </>
    );
}
